<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-4">
    @if (!data.allowOtherCatalog) {
      <IAlert [title]="t('asins-selection.bulk_description')" />
    }
    <div class="min-h-0 w-full flex-1">
      <textarea
        class="h-full min-h-0 w-full"
        data-testid="bulk-asin-textarea"
        [(ngModel)]="bulkInput"
        [placeholder]="t('strategy-asins.enter_list_of_asins')"
      ></textarea>
    </div>

    <div class="flex justify-end gap-4">
      <button iButton variant="secondary" size="md" (click)="modalRef.close()">Cancel</button>
      <button
        iButton
        size="md"
        testId="btn-confirm-bulk-asin"
        [disabled]="bulkInput().length === 0"
        (click)="processBulkInput()"
      >
        Confirm bulk selection
      </button>
    </div>
  </div>

  <ng-template #confirmAsinsModal>
    <div>
      <div class="text-sm text-gray-800">
        {{ t("strategy-asins.some_asins_are_invalid_message") }}
      </div>
      <ul class="mt-2 pl-3 text-sm" data-testid="bulk-upload-error">
        @for (error of bulkErrors(); track error) {
          <li>
            <span class="font-medium">{{ error.asin }}</span> - {{ error.error }}
          </li>
        }
      </ul>
    </div>
    <div class="flex justify-end gap-2">
      <button iButton variant="secondary" size="sm" (click)="confirmAsinsModalRef?.close()">Cancel</button>
      <button iButton size="sm" testId="btn-confirm-bulk-asin" (click)="emitBulkSelection()">
        {{ t("asins-selection.ignore_invalid_asins") }}
      </button>
    </div>
  </ng-template>
</ng-container>
